'use client';
import React, { useState } from 'react';
import styles from './scss/segmentation.module.scss';
import SegMent1 from './Segment1';
import SegMent2 from './Segment2';
import SegMent3 from './Segment3';
import SegMent4 from './Segment4';

const Segmentation = ({ onComplete }: { onComplete?: () => void }) => {
  const [seg1Done, setSeg1Done] = useState(false);
  const [seg2Done, setSeg2Done] = useState(false);
  const [seg3Done, setSeg3Done] = useState(false);

  return (
    <div className={styles.segmentationsec}>
      <p className={styles.paratxt}>
        Customers by shared traits to deliver <br /> targeted experiences.
      </p>
      <SegMent1 onComplete={() => setSeg1Done(true)} />

      {seg1Done && <SegMent2 onComplete={() => setSeg2Done(true)} />}
      <div className={styles.chartandsummary}>
        {seg2Done && <SegMent3 onComplete={() => setSeg3Done(true)} />}
        {seg3Done && <SegMent4 onComplete={onComplete} />}
      </div>

    </div>
  );
};

export default Segmentation;
